import { PendingSend, retryTextMessage } from "../../lib/redux/sessions/texting/slice"
import React from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { MessageBubble } from './MessageBubble';

export interface PendingTextProps {
    text: PendingSend;
}

const styles = {
    messageContainer: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '4px',
        paddingLeft: '16px',
        paddingRight: '16px',
    },
    messageRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '8px',
    },
    message: {
        maxWidth: '85%',
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '2px',
    },
    timestamp: {
        fontSize: '11px',
        color: '#6b7280',
        marginTop: '2px',
        textAlign: 'right' as const,
    },
    statusIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
    },
    retryButton: {
        backgroundColor: 'transparent',
        border: 'none',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        width: '24px',
        height: '24px',
        color: '#dc2626',
        opacity: 0.8,
        transition: 'all 0.2s ease',
        ':hover': {
            opacity: 1,
            transform: 'scale(1.1)',
        }
    },
    loadingIcon: {
        color: '#6366f1',
        opacity: 0.8,
        animation: 'spin 1s linear infinite',
    }
};

export function PendingText({ text }: PendingTextProps) {
    const dispatch = useDispatch();
    const isFailed = text.status.status === 'failed';
    
    return (
        <div style={styles.messageContainer}>
            <div style={styles.messageRow}>
                {text.status.status === 'pending' && (
                    <div style={styles.statusIcon}>
                        <Loader2 size={16} style={styles.loadingIcon} />
                    </div>
                )}
                {isFailed && (
                    <button 
                        style={styles.retryButton} 
                        onClick={() => retryTextMessage(text, dispatch)}
                        title="Retry sending message"
                    >
                        <RefreshCw size={16} />
                    </button>
                )}
                <div style={styles.message}>
                    <MessageBubble isAgent={true}>
                        {text.message}
                    </MessageBubble>
                    <div style={styles.timestamp}>
                        {new Date(text.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </div>
                </div>
            </div>
        </div>
    );
}